export default "__VITE_ASSET__CjAsxz29__"